// Generated by scripts/generate-icons.ts from docs/design/icons. Do not edit by hand.
import type { IconShape } from "./types";

export const sourceIcons = {
  /** docs/design/icons/agente.svg */
  agent: [
    ["path", { d: "M7 3h6a4 4 0 0 1 4 4v6a4 4 0 0 1-4 4H3V7a4 4 0 0 1 4-4z" }],
    ["path", { d: "M8 8.5v2M12 8.5v2" }],
  ],
  /** docs/design/icons/aguardando.svg */
  waiting: [
    ["circle", { cx: "10", cy: "10", r: "7" }],
    ["path", { d: "M10 6v4l2.6 1.8" }],
  ],
  /** docs/design/icons/anexo.svg */
  attach: [["path", { d: "m14.6 9.4-5.1 5.1a3 3 0 0 1-4.2-4.2l6-6a2 2 0 0 1 2.8 2.8l-6 6a1 1 0 0 1-1.4-1.4l5.1-5.1" }]],
  /** docs/design/icons/aprovar.svg */
  approve: [
    ["path", { d: "M7 3h6a4 4 0 0 1 4 4v6a4 4 0 0 1-4 4H3V7a4 4 0 0 1 4-4z" }],
    ["path", { d: "m7 10.2 2 2 4-4.4" }],
  ],
  /** docs/design/icons/busca.svg */
  search: [
    ["circle", { cx: "8.8", cy: "8.8", r: "5.3" }],
    ["path", { d: "m12.8 12.8 4.2 4.2" }],
  ],
  /** docs/design/icons/canal.svg */
  channel: [["path", { d: "M8.2 3 6.6 17M13.4 3l-1.6 14M3.5 7.5h13M3 12.5h13" }]],
  /** docs/design/icons/enviar.svg */
  send: [["path", { d: "M10 16.5v-13M5 8.5l5-5 5 5" }]],
  /** docs/design/icons/mensagem.svg */
  message: [["path", { d: "M6.5 4h7.5a3 3 0 0 1 3 3v4a3 3 0 0 1-3 3H3V7.5A3.5 3.5 0 0 1 6.5 4z" }]],
  /** docs/design/icons/pessoa.svg */
  person: [
    ["circle", { cx: "10", cy: "7", r: "3.2" }],
    ["path", { d: "M4.2 17c.7-3 3-4.6 5.8-4.6s5.1 1.6 5.8 4.6" }],
  ],
} satisfies Record<string, IconShape[]>;
